import 'css-chunksrc/client/common/resourceAllocationMenu/section/styles.scss';export default {
  "header": "_header_1krrc_1",
  "iconBox": "_iconBox_1krrc_10",
  "icon": "_icon_1krrc_10",
  "list": "_list_1krrc_24",
  "customList": "_customList_1krrc_29",
  "open": "_open_1krrc_36"
};